module.exports = __webpack_public_path__ + "assets/img/Rosemary-Health-2-Social-Static-Ad-w720.58f05de5.webp";